// extracted by mini-css-extract-plugin
export default {"clrTundora":"#4D4D4D","backButton":"BackToIdpButton_backButton__HYeAR"};